import { SVGProps } from 'react'

export const MasterCard = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="27"
      height="17"
      viewBox="0 0 27 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M16.9227 2.30359H9.95117V14.8317H16.9227V2.30359Z" fill="#FF5F00" />
      <path
        d="M10.394 8.56748C10.3929 7.36094 10.6663 6.16996 11.1935 5.0847C11.7207 3.99944 12.488 3.04835 13.4371 2.30343C12.2617 1.37956 10.8501 0.805023 9.36368 0.64548C7.87722 0.485936 6.37586 0.747828 5.0312 1.40122C3.68654 2.05461 2.55284 3.07314 1.75968 4.34039C0.966518 5.60764 0.545898 7.07248 0.545898 8.56748C0.545898 10.0625 0.966518 11.5273 1.75968 12.7946C2.55284 14.0618 3.68654 15.0804 5.0312 15.7338C6.37586 16.3871 7.87722 16.649 9.36368 16.4895C10.8501 16.33 12.2617 15.7554 13.4371 14.8315C12.488 14.0866 11.7208 13.1355 11.1935 12.0503C10.6663 10.965 10.3929 9.77403 10.394 8.56748Z"
        fill="#EB001B"
      />
      <path
        d="M26.3283 8.56748C26.3284 10.0625 25.9078 11.5273 25.1147 12.7946C24.3216 14.0618 23.1879 15.0803 21.8433 15.7337C20.4986 16.3871 18.9973 16.649 17.5108 16.4895C16.0244 16.33 14.6128 15.7554 13.4375 14.8315C14.3858 14.0859 15.1524 13.1346 15.6796 12.0495C16.2067 10.9645 16.4806 9.77384 16.4806 8.56748C16.4806 7.36113 16.2067 6.17052 15.6796 5.08543C15.1524 4.00034 14.3858 3.0491 13.4375 2.30343C14.6128 1.37956 16.0244 0.80502 17.5108 0.645478C18.9973 0.485937 20.4986 0.747833 21.8433 1.40123C23.1879 2.05463 24.3216 3.07317 25.1147 4.34042C25.9078 5.60767 26.3284 7.0725 26.3283 8.56748Z"
        fill="#F79E1B"
      />
      <path
        d="M25.5672 13.5043V13.2478H25.6706V13.1956H25.4072V13.2478H25.5107V13.5043H25.5672ZM26.0786 13.5043V13.1951H25.9978L25.905 13.4078L25.8121 13.1951H25.7313V13.5043H25.7883V13.2711L25.8754 13.4722H25.9345L26.0216 13.2705V13.5043H26.0786Z"
        fill="#F79E1B"
      />
    </svg>
  )
}
